import React, { createContext, useContext, useLayoutEffect } from "react";
import { activeTheme } from "../themes";

const ThemeContext = createContext(activeTheme);

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
    useLayoutEffect(() => {
        // Update favicon to the theme-specific asset
        document
            .querySelectorAll("link[rel~='icon']")
            .forEach((link) => {
                link.href = activeTheme.assets.favicon;
            });
    }, []);

    return (
        <ThemeContext.Provider value={activeTheme}>
            {children}
        </ThemeContext.Provider>
    );
};
